import React, { FC } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface ReliabilityWordPressStepsProps {
    wordPressData: any
}

const ReliabilityWordPressSteps: FC<ReliabilityWordPressStepsProps> = ({ wordPressData }) => {
    return (
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12 lg:gap-16 p-6 md:p-12 lg:p-20 pt-12 lg:pt-16 px-4 md:px-20 lg:px-36'>
            {wordPressData.ReliabilityWordPressData.map((reliable: any, index: number) => {
                return (
                    <CardItem key={index} reliable={reliable} index={index} />
                )
            })}
        </div>
    )
}

// Separate component for each card to handle individual animations
const CardItem = ({ reliable, index }: { reliable: any, index: number }) => {
    const ref = React.useRef(null)
    const isInView = useInView(ref, { once: false, amount: 0.3 })
     let img = getImage(reliable.image ?? "") ?? "";
    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{
                duration: 0.5,
                delay: index * 0.1,
                ease: "easeOut"
            }}
        >
            <motion.div className='relative p-[1px] flex rounded-3xl' whileHover={{
                        backgroundImage: `linear-gradient(354.61deg, ${reliable.bgColor} -38.83%, rgba(255, 185, 18, 0) 91.93%)`
                    }}>
                <motion.div className='bg-blackDark  p-6 md:p-8 pt-14 md:pt-16 rounded-3xl w-full'
                    >
                    <motion.div
                        className='absolute -top-8 w-16 md:w-20 h-16 md:h-20 rounded-full flex items-center justify-center left-[38%] -translate-x-1/2 bg-blackDarkThemePrimary'
                        initial={{ scale: 0 }}
                        animate={isInView ? { scale: 1 } : { scale: 0 }}
                        transition={{
                            duration: 0.5,
                            delay: index * 0.1 + 0.2,
                            type: "spring",
                            stiffness: 200
                        }}

                    >
                        <div className='flex items-center justify-center text-black font-black text-xl'>
                            {/* <img src={reliable.image} className='w-4/5' alt={reliable.title} /> */}
                            <DynamicSVG size='w-4/5'>{img}</DynamicSVG>
                        </div>
                    </motion.div>
                    <div className='flex flex-col gap-1 text-center'>
                        <motion.span
                            className={`text-lg md:text-xl font-medium text-white`}
                            initial={{ opacity: 0 }}
                            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 + 0.3 }}
                        >
                            <b>{reliable.title}:</b>
                        </motion.span>
                        <motion.span
                            className='text-sm md:text-base'
                            initial={{ opacity: 0 }}
                            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 + 0.4 }}
                        >
                            {reliable.subtitle}
                        </motion.span>
                    </div>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default ReliabilityWordPressSteps
